module.exports = __webpack_public_path__ + "img/logo_white.c4304d7.svg";